const util = {
	isUndefined: (value) => value === undefined,
	isNumber: (value) => typeof value === 'number' && isFinite(value),
	isString: (value) => typeof value === 'string' || value instanceof String,
	isObject: (value) => value !== null && typeof value === 'object' && !Array.isArray(value) && typeof value !== 'function',
}

export default util;